import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=63a21f0d&scoped=true"
import script from "./avatar.vue?vue&type=script&lang=js"
export * from "./avatar.vue?vue&type=script&lang=js"
import style0 from "./avatar.vue?vue&type=style&index=0&id=63a21f0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a21f0d",
  null
  
)

export default component.exports